import axios from '@/lib/axios';
import { PaymentInfo } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2320. クレジットカード更新
 * [PUT] /workspaces/:identifier/payment_method
 */
type Props = {
  identifier: string;
  setup_intent_id: string;
};
const updatePaymentMethod = (props: Props): Promise<PaymentInfo> => {
  return axios.put(`/api/workspaces/${props.identifier}/payment_method`, props);
};

export const useUpdatePaymentMethod = () => {
  return useMutation({
    mutationFn: updatePaymentMethod,
  });
};
